export type LoginTestimonial = {
  name: string;
  image: string;
  text: string;
  textClass?: string;
};

export const LOGIN_TESTIMONIALS: LoginTestimonial[] = [
  {
    name: 'Arun Mathew',
    image: '/login-assets/images/no-image-male.png',
    textClass: 'lg-card-text',
    text: "I can't believe how much this has helped me. I've already made like 50 resumes for different job applications, and editing each one was so easy because everything is broken down really well. The Enhance and Analyze features are honestly my favorite — the analysis actually tells me what to fix, and honestly, you are sticking to what you are promising. I've got an interview next week and I'm definitely going to use the Interview Prep feature. The AI part is so good — I love the way it structures my resume.",
  },
  {
    name: 'Vijitha M',
    image: '/login-assets/images/vijitha-m.jpg',
    text: 'I got a new job using a resume I created with kudoswall resume builder. The step by step guidence helps me to create resume easily saved me a lot of time and made my resume look polished and professional. Very happy with the results.',
  },
  {
    name: 'Suraj singh',
    image: '/login-assets/images/suraj-singh.png',
    text: 'Very great content is very easily available 👍 All the role related points you can select whereever relatesyou. Efficient and easy',
  },
  {
    name: 'Shruti',
    image: '/login-assets/images/no-image-female.png',
    text: 'Best website about easy to use and customer service is very quick to respond',
  },
  {
    name: 'Amol Pandey',
    image: '/login-assets/images/amol-pandey.png',
    textClass: 'md-card-text',
    text: "I was honestly surprised by how easy and user-friendly KudosWall was. I built my resume in just 15 minutes, and the cover letter was auto-generated based on my resume—which was super helpful! I even got two interview callbacks soon after. One feature I'd really love to see is a Job Board. I recently found out that many jobs on LinkedIn aren't genuine, so having trusted opportunities directly on KudosWall would be a game-changer.",
  },
  {
    name: 'Dwijendra Pandey',
    image: '/login-assets/images/no-image-male.png',
    text: 'I found the platform really user-friendly, and the templates were genuinely impressive. I used both the cover letter and CV builder, and they worked great for me. The Analyze feature was especially helpful — it gave me clear insights to improve my resume. I\'d love to see even more template options in the future.',
  },
  {
    name: 'R Divya Priyanka',
    image: '/login-assets/images/r-divya-priyanka.jpg',
    text: '10/10. I got a job thanks to KudosWall! I really love the simple templates, especially the one with the round photo in the center — it looks clean and professional. I\'d love to see even more template options in the future.',
  },
  {
    name: 'Saiganesh Venkatesh',
    image: '/login-assets/images/saiganesh-venkatesh.png',
    text: "I discovered KudosWall through YouTube Shorts, and it's been a great find! It created a neat one-page resume that helped me get interview calls quickly.. What I appreciate most is their affordable 1-year plan — great value for everything you get. I've already recommended KudosWall to 3-4 friends because it truly delivers!",
  },
  {
    name: 'Sneha Rajeev',
    image: '/login-assets/images/no-image-female.png',
    text: 'The template was excellent, and the tool worked flawlessly. I was particularly impressed with how the content was arranged exactly as I wanted it.',
  },
  {
    name: 'Mohammed Sabeer M A',
    image: '/login-assets/images/mohammed-sabeer.png',
    textClass: 'lg-card-text',
    text: '"Simple, economical, and effective – exactly what I needed." I came across KudosWall while searching for an ATS-compatible resume solution. After applying for jobs again after five years, many websites flagged my old biodata as outdated. But with KudosWall, I could simply upload and enhance my old resume — the process was smooth and seamless. The templates are clean, modern, and ATS-friendly. I first tried the trial, then upgraded to the weekly plan — and even extended it because I wanted to explore more features. I loved the flexibility, the one-page format, and how everything was easy to follow. Highly satisfied with the result. Would definitely recommend KudosWall to others!',
  },
  {
    name: 'Sneha Muneshwar',
    image: '/login-assets/images/sneha-muneshwar.png',
    text: 'great , very helpful, I received a job interview offer because of the resume I made on KudosWall— I\'m giving the interview in two days! Honestly, I\'m very, very grateful and thankful to your organisation. The tool is perfect, and the price is very affordable compared to others. Thank you so much!',
  },
  {
    name: 'Ayush Bhat',
    image: '/login-assets/images/user-Ayush.jpg',
    text: 'KudosWall not only helped me create an amazing resume but also landed me an interview—and I got selected! Special thanks to Shimpal for the outstanding support!',
  },
  {
    name: 'Sachin Felix ',
    image: '/login-assets/images/user-Sachin.jpg',
    text: 'I quickly became a fan of the Resume Analyzer and the ability to import and improve my resume. Enhanced my job application process.',
  },
  {
    name: 'Sriram',
    image: '/login-assets/images/user-Sriram.jpg',
    text: "I love the Resume Analyzer I'll definitely recommend KudosWall to my friends.",
  },
  {
    name: 'N V K Prasad',
    image: '/login-assets/images/user-Prasad.jpeg',
    text: 'Their user-friendly platform and insightful suggestions for skills and keywords, combined with fantastic customer service, made a huge difference. Feeling confident about my job search!',
  },
  {
    name: 'Raksha Bhavish',
    image: '/login-assets/images/user-Raksha.jpg',
    text: "Kudoswall's platform is fantastic! I loved the AI suggestions and templates, and their customer service was excellent. Highly recommended!",
  },
  {
    name: 'Jamirimna',
    image: '/login-assets/images/user-Jamirimna.jpg',
    text: 'Overall, the experience with KudosWall Resume Builder was good. Overall, its a superb resume builder site.',
  },
];

export const HIRED_BY_COMPANIES = [
  'Amazon',
  'Google',
  'Microsoft',
  'Apple',
  'Cognizant',
  'Tata Steel',
  'JSW Steel',
  'HDFC Bank',
  'Mercedes',
  'Ford Motor',
  'Cipla',
  'Starbucks',
  'Emirates',
  'Air India',
  'Le Meridien',
  'Uber',
];
